import React from "react"
import { styled } from "styled-components"
import { Formation } from "../types"
import { TextInput } from "./TextInput"
import { Button } from "./Button"
import { Checkbox } from "./Checkbox"
import { red, white, yellow } from "./colors"

const ErrorMessage = styled.div`
  color: ${red};
  text-align: center;
  width: 100%;
  font-size: 20px;
  font-weight: bold;
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 60dvw;
  margin: 16px;
  padding: 12px 24px;
  gap: 2px;
  border: 4px solid ${yellow};
  border-radius: 16px;
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 12px;
  width: 100%;
  flex-grow: 1;
`
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  flex-grow: 1;
  gap: 12px;
  margin-top: 22px;
`

const Text = styled(TextInput)`
  width: 70%;
`

const Title = styled.div`
  color: ${white};
  text-transform: uppercase;
  width: 100%;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  flex-grow: 0;
`

export const SavePlayForm: React.FC<{
  play: Formation
  label?: string
  onCancel?: () => void
  onSubmitPlay: ({
    saveAsNew,
    name
  }: {
    saveAsNew: boolean
    name?: string
  }) => void
  isSubmitPlayPending?: boolean
  isSubmitPlayError?: boolean
  playNameList?: string[]
}> = ({
  play,
  label,
  onSubmitPlay,
  onCancel,
  isSubmitPlayError = false,
  isSubmitPlayPending = false,
  playNameList = []
}) => {
  const isCustomPlay = play.category === "Custom"
  const [name, setName] = React.useState<string>(isCustomPlay ? play.name : "")
  const [error, setError] = React.useState<string | null>(null)
  const [saveAsNew, setSaveAsNew] = React.useState<boolean>(true)

  const handleSubmitPlay = () => {
    const isAlreadyExistingPlay = playNameList.includes(name)
    if (isAlreadyExistingPlay && saveAsNew) {
      setError(
        "Name already exists. Please choose a different name."
      )
      return
    }
    onSubmitPlay({ saveAsNew, name })
  }

  const handleNameChange = (newName: string) => {
    // If we're having the dupes error, let's clear it when the user starts typing a new name
    if (error) {
      setError(null)
    }
    setName(newName)
  }
  console.log("isSubmitPlayPending", isSubmitPlayPending)
  return (
    <FormContainer>
      <Title>Saving the play</Title>
      {isSubmitPlayError && (
        <ErrorMessage>
          Something went wrong while saving the play. Please try again!
        </ErrorMessage>
      )}
      <InputContainer>
        <Text
          value={saveAsNew ? name : play.name}
          onChange={handleNameChange}
          label="Play name"
          placeholder="Enter the name of the play..."
          required
          error={error || undefined}
          disabled={!saveAsNew}
        />
        {isCustomPlay && (
          <div style={{ marginTop: '22px' }}>
            <Checkbox
              label="As new"
              checked={saveAsNew}
              onChange={setSaveAsNew}
            />
          </div>
        )}
        <ButtonContainer>
          <Button
            onClick={handleSubmitPlay}
            disabled={isSubmitPlayPending || !name}
          >
            {isSubmitPlayPending ? "Saving..." : "Save"}
          </Button>
          {onCancel && (
            <Button onClick={onCancel} secondary>
              cancel
            </Button>
          )}
        </ButtonContainer>
      </InputContainer>
    </FormContainer>
  )
}
